import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lấy thống kê tuyển dụng
export function layThongKeTuyenDung(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/tuyen-dung/thong-ke', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
